<template>
    <div v-if="show" class="chronic-absence-details-modal">
        <v-dialog
            v-if="isModal"
            v-model="show"
            width="90%"
            :footer="false"
            :persistent="true"
            @close="$emit('close')"
            content-class="chronic-absence-details-dialog"
            :retain-focus="false"
            :overlay="false"
        >
            <v-card>
                <v-card-title>
                    <div class="d-flex" style="width: 100%;">
                        <div class="d-flex align-center ml-4">{{ title }}</div>
                        <v-spacer/>
                        <fe-icon-btn class="close-icon" useIcon="fal fa-times" @click="$emit('close')"/>
                    </div>
                </v-card-title>
                <v-card-text>
                    <div class="chronic-absence-details d-flex flex-column flex-fill">
                        <v-dialog
                            scrollable
                            persistent
                            v-model="showAbsenceCountModal"
                            width="90%"
                            height="90%"
                            :footer="false"
                            @close="showAbsenceCountModal = false"
                            content-class="absence-count-modal"
                        >
                            <v-card v-if="showAbsenceCountModal" class="absence-count-card">
                                <v-card-title>
                                    <div class="d-flex" style="width: 100%;">
                                        <div class="d-flex align-center">{{ absenceCountModalTitle }}</div>
                                        <v-spacer/>
                                        <fe-icon-btn class="close-icon" useIcon="fal fa-times" @click="showAbsenceCountModal = false"/>
                                    </div>
                                </v-card-title>
                                <v-card-text>
                                    <student-attendance
                                        :params="absenceCountParams"
                                        :initialViewType="'count'"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-dialog>

                        <v-slide-y-transition>
                            <div v-if="selectedStudents.length > 0" class="selection-toolbar d-flex">
                                <div class="mt-3 ml-5">{{ selectedStudents.length }} selected</div>
                                <div class="ml-auto">
                    <fe-btn usage="ghost" dark useIcon="fal fa-tag" @click="tagStudents" data-test="bulk-apply-tag-btn">
                        Apply Tag
                    </fe-btn>
                    <fe-btn usage="ghost" dark useIcon="fal fa-times" @click="$refs.grid.gridApi.deselectAll()" data-test="bulk-action-cancel-btn">
                        Cancel
                    </fe-btn>
                                </div>
                            </div>
                        </v-slide-y-transition>

                        <div class="flex-grow-1" :style="{ height: dynamicContainerHeight }">
                            <fe-spinner v-if="displayLoading" />
                            
                            <fe-grid
                                v-else
                                ref="grid"
                                :rowData="displayStudents"
                                :columnDefs="columnDefs"
                                :exportFilename="csvFilename"
                                :csvExportProcessCallback="csvExportProcessCallback"
                                displayDensity="medium"
                                domLayout="normal"
                                :showAddRowBtn="false"
                                :showToolbar="true"
                                :bordered="true"
                                class="flex-grow-1"
                                style="height: 100%;"
                                rowSelection="multiple"
                                :suppressRowClickSelection="true"
                                :gridOptionOverrides="gridOptions"
                                @cellClicked="showStudentCard"
                                @rowDataChanged="updateStudentCount"
                                @gridReady="onGridReady"
                                @selectionChanged="onSelectionChanged"
                                :frameworkComponents="frameworkComponents"
                                :defaultColDefOverrides="defaultColDef"
                            >
                                <template #after-search-toolbar-items>
                                    <div class="student-count-display">
                                        <h5 class="student-count-text">{{ studentCount ? studentCount.toLocaleString() : 0 }} Students</h5>
                                    </div>
                                </template>
                    <template #toolbar-items>
                        <fe-btn usage="ghost" useIcon="far fa-tag" @click="tagAllStudents" data-test="modal-tag-all-students-btn" class="tag-all-students-btn">
                            Tag All Students
                        </fe-btn>
                    </template>
                            </fe-grid>
                        </div>

                        <fe-student-card
                            ref="studentCard"
                            :style="{
                                position: 'fixed',
                                left: `${studentCard.left}px`,
                                top: `${studentCard.top}px`,
                                padding: '1px 6px 1px 6px',
                                zIndex: '10'
                            }"
                            :imageUrl="studentCard.imageUrl"
                            :studentRecord="studentCard.studentRecord"
                            v-show="studentCard.show"
                            fullNameField="student_full_name"
                            schoolField="school_name"
                            gradeField="grade_level"
                            genderField="gender"
                            :modal="true"
                            @close="hideStudentCard"
                        >
                            <template #header>
                                <div class="d-flex justify-end">
                                    <fe-icon-btn
                                        useIcon="fal fa-times"
                                        usage="ghost"
                                        @click="hideStudentCard"
                                    />
                                </div>
                            </template>
                            <div class="student-actions">
                                <fe-btn
                                    @click="handleViewStudentProfile"
                                    usage="primary"
                                    data-test="view-student-profile-btn"
                                >
                                    View Student Profile
                                </fe-btn>
                                <fe-btn
                                    @click="handleViewAbsenceCount"
                                    usage="secondary"
                                    data-test="view-absence-count-btn"
                                >
                                    View Absence Count
                                </fe-btn>
                            </div>
                        </fe-student-card>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div v-else class="chronic-absence-details d-flex flex-column flex-fill">
            <v-dialog
                v-model="showAbsenceCountModal"
                :footer="false"
                scrollable
                persistent
                content-class="absence-count-modal"
                @close="showAbsenceCountModal = false"
            >
                <v-card v-if="showAbsenceCountModal" class="absence-count-card">
                    <v-card-title>
                        <div class="d-flex" style="width: 100%;">
                            <div class="d-flex align-center">{{ absenceCountModalTitle }}</div>
                            <v-spacer/>
                            <fe-icon-btn class="close-icon" useIcon="fal fa-times" @click="showAbsenceCountModal = false"/>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <student-attendance
                            :params="absenceCountParams"
                            :initialViewType="'count'"
                        />
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-slide-y-transition>
                <div v-if="selectedStudents.length > 0" class="selection-toolbar selection-toolbar-datawall d-flex">
                    <div class="mt-3 ml-5">{{ selectedStudents.length }} selected</div>
                    <div class="ml-auto">
                        <fe-btn usage="ghost" dark useIcon="fal fa-tag" @click="tagStudents" data-test="bulk-apply-tag-btn">
                            Apply Tag
                        </fe-btn>
                        <fe-btn usage="ghost" dark useIcon="fal fa-times" @click="$refs.grid.gridApi.deselectAll()" data-test="bulk-action-cancel-btn">
                            Cancel
                        </fe-btn>
                    </div>
                </div>
            </v-slide-y-transition>

            <div class="flex-grow-1 datawall-container" :style="{ height: dynamicContainerHeight }">
                <fe-spinner v-if="displayLoading" />
                
                <fe-grid
                    v-else
                    ref="grid"
                    :rowData="displayStudents"
                    :columnDefs="columnDefs"
                    :exportFilename="csvFilename"
                    :csvExportProcessCallback="csvExportProcessCallback"
                    displayDensity="medium"
                    domLayout="normal"
                    :showAddRowBtn="false"
                    :showToolbar="true"
                    :bordered="true"
                    class="flex-grow-1"
                    :style="isModal ? { height: '100%' } : { height: dynamicContainerHeight }"
                    rowSelection="multiple"
                    :suppressRowClickSelection="true"
                    :gridOptionOverrides="gridOptions"
                    @cellClicked="showStudentCard"
                    @rowDataChanged="updateStudentCount"
                    @gridReady="onGridReady"
                    @selectionChanged="onSelectionChanged"
                    :frameworkComponents="frameworkComponents"
                    :defaultColDefOverrides="defaultColDef"
                >
                    <template #after-search-toolbar-items>
                        <div class="student-count-display">
                            <h5 class="student-count-text">{{ studentCount ? studentCount.toLocaleString() : 0 }} Students</h5>
                        </div>
                    </template>
                    <template #toolbar-items>
                        <fe-btn usage="ghost" useIcon="far fa-tag" @click="tagAllStudents" data-test="datawall-tag-all-students-btn" class="tag-all-students-btn">
                            Tag All Students
                        </fe-btn>
                    </template>
                </fe-grid>
            </div>

            <fe-student-card
                ref="studentCard"
                :style="{
                    position: 'fixed',
                    left: `${studentCard.left}px`,
                    top: `${studentCard.top}px`,
                    padding: '1px 6px 1px 6px',
                    zIndex: '10'
                }"
                :imageUrl="studentCard.imageUrl"
                :studentRecord="studentCard.studentRecord"
                v-show="studentCard.show"
                fullNameField="student_full_name"
                schoolField="school_name"
                gradeField="grade_level"
                genderField="gender"
                :modal="true"
                @close="hideStudentCard"
            >
                <template #header>
                    <div class="d-flex justify-end">
                        <fe-icon-btn
                            useIcon="fal fa-times"
                            usage="ghost"
                            @click="hideStudentCard"
                        />
                    </div>
                </template>
                <div class="student-actions">
                    <fe-btn
                        @click="handleViewStudentProfile"
                        usage="primary"
                        data-test="view-student-profile-btn"
                    >
                        View Student Profile
                    </fe-btn>
                    <fe-btn
                        @click="handleViewAbsenceCount"
                        usage="secondary"
                        data-test="view-absence-count-btn"
                    >
                        View Absence Count
                    </fe-btn>
                </div>
            </fe-student-card>
        </div>

        <tag-student v-if="studentsToTag && studentsToTag.show" v-model="studentsToTag.show" :students="studentsToTag.students" @saved="clearSelections"/>
    </div>
</template>

<script>
import StudentAttendance from '@/components/modules/attendanceReporting/StudentAttendance'
import TagStudent from '@/components/common/TagStudent'
import { mapState } from 'vuex'

export default {
    name: 'ChronicAbsenceDetails',
    components: {
        StudentAttendance,
        TagStudent
    },
    
    emits: ['goToStudentProfile', 'close', 'tagsUpdated'],
    
    props: {
        students: {
            type: Array,
            default: () => []
        },
        columnDefs: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        isModal: {
            type: Boolean,
            default: true
        },
        drilldownParams: {
            type: Object,
            default: () => ({})
        },
        csvFilename: {
            type: String,
            default: 'Chronically Absent Students'
        },
        containerHeight: {
            type: String,
            default: null
        },
        frameworkComponents: {
            type: Object,
            default: () => ({})
        },
        scoreFilters: {
            type: Array,
            default: () => []
        },
    },
    
    data() {
        return {
            selectedStudents: [],
            studentCard: {
                show: false,
                left: 0,
                top: 0,
                imageUrl: null,
                studentRecord: null
            },
            showAbsenceCountModal: false,
            absenceCountModalTitle: '',
            absenceCountParams: null,
            studentCount: 0,
            defaultColDef: {
                headerComponent: undefined,
            },
        }
    },
    
    created() {
        this.restoreColumnPreferences()
    },
    
    computed: {
        ...mapState('global', ['studentsToTag']),
        displayStudents() {
            let results = this.students
            let filtered = []
            if (this.scoreFilters.length) {
                this.scoreFilters.forEach(sf => {
                    let ids = new Set(filtered.map(d => d.student_id))
                    if (sf.type === 'interventionLevel') {
                        if (sf.filters.interventionLevels?.length > 0) {
                            let newFilter = results.filter(itm => sf.filters.interventionLevels.find(l => `${itm[sf.field]}`.toLowerCase().includes(l.toLowerCase())))
                            filtered = [...filtered, ...newFilter.filter(d => !ids.has(d.student_id))]
                        }
                    }
                })
            }
            return filtered.length ? filtered : results
        },
        gridOptions() {
            return {
                immutableData: true,
                getRowNodeId: (data) => {
                    return data.student_id
                }
            }
        },
        displayLoading() {
            return this.loading
        },
        dynamicContainerHeight() {
            // If containerHeight prop is provided (e.g., from main page with viewport calculation), use it
            if (this.containerHeight) {
                return this.containerHeight
            }
            // Otherwise, use row-based calculation (for modal)
            const headerRowHeight = 57 // Header row height
            const dataRowHeight = 40 // Data row height
            const toolbarHeight = 64 // Toolbar height
            const maxHeight = 540 // Maximum height before grid becomes scrollable
            const calculatedHeight = toolbarHeight + headerRowHeight + (this.displayStudents.length * dataRowHeight)
            
            return (calculatedHeight > maxHeight || !this.displayStudents.length ? maxHeight : calculatedHeight) + 'px'
        }
    },

    watch: {
        displayStudents: {
            handler() {
                this.$nextTick(() => {
                    this.updateStudentCount()
                })
            }
        },
        show: {
            handler(newValue) {
                if (!newValue) {
                    this.clearSelections()
                }
            }
        },
        'studentCard.show'(visible) {
            if (visible) {
                this.$nextTick(() => {
                    document.addEventListener('click', this.onStudentCardClickOutside)
                })
            } else {
                document.removeEventListener('click', this.onStudentCardClickOutside)
            }
        }
    },

    beforeDestroy() {
        document.removeEventListener('click', this.onStudentCardClickOutside)
    },
    
    methods: {
        showStudentCard(meta) {
            if (meta.colDef.field === "student_full_name" && meta.data) {
                const cellElement = meta.event.target.closest('.ag-cell')
                const cellRect = cellElement.getBoundingClientRect()
                
                // Vertically position higher at the bottom to avoid covering button
                const estimatedCardHeight = 260
                const padding = 20
                
                let top = cellRect.top
                if (top + estimatedCardHeight > window.innerHeight - padding) {
                    top = cellRect.top - estimatedCardHeight - 10
                    top = Math.max(padding, top)
                }
                
                this.studentCard = {
                    show: true,
                    left: cellRect.right,
                    top: top,
                    imageUrl: meta.data.image_url || null,
                    studentRecord: meta.data
                }
            } else if (meta.colDef.field === 'interventions') {
                this.$dockableWindow({
                    name: 'Intervention Groups',
                    component: 'intervention-workspace',
                    attrs: {
                        interventionPlanId: meta.data.intervention_plan_id
                    }
                })
            } 
        },

        hideStudentCard() {
            this.studentCard.show = false
        },

        onStudentCardClickOutside(event) {
            if (!this.studentCard.show) {
                return
            }
            const cardRef = this.$refs?.studentCard
            const root = cardRef && (cardRef?.$el || cardRef)
            if (root && root.contains && root.contains(event.target)) {
                return
            }
            this.hideStudentCard()
        },

        csvExportProcessCallback(params) {
            // Use ag-grid's built-in export with only visible columns
            this.$refs.grid.gridApi.exportDataAsCsv({
                fileName: params.fileName,
                allColumns: false,
                onlySelected: false
            })
        },

        onSelectionChanged() {
            this.selectedStudents = this.$refs.grid.gridApi.getSelectedRows()
        },

        tagStudents() {
            const me = this
            this.$store.commit('global/tagStudents', {
                show: true,
                students: this.selectedStudents,
                callback() {
                    me.$emit('tagsUpdated')
                }
            })
        },

        tagAllStudents() {
            const me = this
            this.$store.commit('global/tagStudents', {
                show: true,
                students: this.displayStudents,
                callback() {
                    me.$emit('tagsUpdated')
                }
            })
        },
        
        clearSelections() {
            this.$refs?.grid?.gridApi?.deselectAll()
            this.selectedStudents = []
        },

        handleViewAbsenceCount() {
            this.absenceCountModalTitle = this.studentCard.studentRecord.student_full_name + ' Attendance'
            this.absenceCountParams = {
                student_id: this.studentCard.studentRecord.student_id,
                school_year_id: this.drilldownParams.school_year_id
            }
            this.showAbsenceCountModal = true
            this.hideStudentCard()
        },
        
        handleViewStudentProfile() {
            const schoolYearId = this.drilldownParams.school_year_id
            this.$emit('goToStudentProfile', this.studentCard.studentRecord.student_id, schoolYearId)
            this.hideStudentCard()
        },

        updateStudentCount() {
            this.studentCount = this.$refs?.grid?.displayedRowCount()
        },

        onGridReady(grid) {
            this.updateStudentCount()
            
            // Set up column visibility change listener to save hide/show preferences
            const me = this
            grid.api.addGlobalListener(function(type, event) {
                if (type.indexOf("column") >= 0) {
                    if (event.type === "columnVisible") {
                        me.columnDefs.forEach(column => {
                            if (column.field === event.column.colDef.field) {
                                column.hide = !event.column.visible
                            }
                        })
                        
                        me.saveColumnPreferences()
                    }
                }
            })
        },

        saveColumnPreferences() {
            try {
                const preferences = {}
                this.columnDefs.forEach(column => {
                    preferences[column.field] = column.hide || false
                })
                sessionStorage.setItem('chronicAbsence_columnPreferences', JSON.stringify(preferences))
            } catch (error) {
                console.warn('Failed to save column preferences:', error)
            }
        },

        restoreColumnPreferences() {
            try {
                const savedPreferences = sessionStorage.getItem('chronicAbsence_columnPreferences')
                if (savedPreferences) {
                    const preferences = JSON.parse(savedPreferences)
                    this.columnDefs.forEach(column => {
                        if (preferences.hasOwnProperty(column.field)) {
                            column.hide = preferences[column.field]
                        }
                    })
                }
            } catch (error) {
                console.warn('Failed to restore column preferences:', error)
            }
        }
    }
}
</script>

<style scoped>
.chronic-absence-details {
    padding: 16px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.student-actions {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-top: 16px;
}

.student-count-display {
    display: flex;
    align-items: center;
    padding: 0 16px;
}

.student-count-text {
    font-size: 14px;
    font-weight: 600;
}

::v-deep .fe-student-card-overlay {
    display: none;
}

.absence-count-modal {
    z-index: 3000 !important;
}

.absence-count-card {
    height: 90vh;
    display: flex;
    flex-direction: column;
}

.selection-toolbar {
    width: calc(100% - 80px);
    position: absolute;
    background: #006C90;
    color: white;
    z-index: 10;
    border-radius: 4px;
}

.selection-toolbar-datawall {
    width: calc(100% - 112px);
    margin-left: 36px;
}

.tag-all-students-btn ::v-deep .fe-button.ghost {
    color: #006C90 !important;
    background: transparent !important;
}

.tag-all-students-btn ::v-deep .fe-button.ghost:hover {
    color: #005673 !important;
    background-color: #ECEDF1 !important;
}

.chronic-absence-details-dialog {
    max-height: 90vh !important;
    min-height: 200px !important;
    height: auto !important;
    display: flex;
    flex-direction: column;
}

.datawall-container {
    padding: 0 36px;
}
</style> 
